import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { usePagedList } from '../lib/usePagedList';
import { LoadMore } from '../components/LoadMore';
import { RoleForm } from '../components/RoleForm';
import { ErrorNotice, JobStatusBadge } from '../components/Status';

export function JobsPage() {
  const { items: jobs, hasMore, loading, loadingMore, error, reload, loadMore } = usePagedList(api.listJobs);
  const [creating, setCreating] = useState(false);

  return (
    <div className="stack">
      <div className="between">
        <div>
          <h1>Roles</h1>
          <p className="muted">Each role carries its own question set and scoring rubric.</p>
        </div>
        <button onClick={() => setCreating((open) => !open)}>
          {creating ? 'Cancel' : 'New role'}
        </button>
      </div>

      <ErrorNotice error={error} />

      {creating ? (
        <RoleForm
          onSaved={() => {
            setCreating(false);
            void reload();
          }}
        />
      ) : null}

      {loading && jobs.length === 0 ? (
        <p className="muted">Loading roles…</p>
      ) : jobs.length === 0 ? (
        error ? null : (
          <div className="card">
            <h2>No roles yet</h2>
            <p className="muted">
              Create a role to define what the AI interviewer asks about, then invite candidates to it.
            </p>
          </div>
        )
      ) : (
        <>
          <div className="grid">
            {jobs.map((job) => (
              <Link key={job.id} to={`/jobs/${job.id}`} className="card stack" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="between">
                  <h2>{job.title}</h2>
                  <JobStatusBadge status={job.status} />
                </div>
                <p className="muted small">
                  {job.seniority}
                  {job.location ? ` · ${job.location}` : ''} · {job.questions.length} questions ·{' '}
                  {job.durationMinutes} min
                </p>
                <p className="small">{job.competencies.join(' · ')}</p>
              </Link>
            ))}
          </div>
          {hasMore ? <LoadMore loading={loadingMore} onLoadMore={loadMore} /> : null}
        </>
      )}
    </div>
  );
}
